import ViewsHelpdesk from '@/views/helpdesk/ViewsHelpdesk.vue';
import {PERMISSIONS} from '@/constants';
import {RouteRecordRaw} from 'vue-router';


export default [
    {
        path: '/helpdesk',
        name: 'helpdesk',
        component: ViewsHelpdesk,
        meta: {
            requiresAuth: true,
            permissions: [PERMISSIONS.HELPDESK]
        }
    }
] as RouteRecordRaw[]